import requests from "@/utils/request";
import store from "@/store";

let request = requests.request;
let lang = store.state.isLang != "zh-CN" ? "en_en" : "zh_cn";

// 换绑手机号->旧号码验证码
export const sendSmsToOldPhoneApi = () =>
  request.post("/sendSmsToOldPhone", { lang });

// 换绑手机号->旧号码提交
export const verifyOldPhoneCodeApi = (data) =>
  request.post("/verifyOldPhoneCode", { lang, isFormData: true, ...data });

// 换绑手机号->新手机提交
export const resetPhoneNumberApi = (data) =>
  request.post("/resetPhoneNumber", { lang, isFormData: true, ...data });

// 换绑邮箱 ->旧邮箱验证码
export const sendCodeToOldEmailApi = () =>
  request.post("/sendCodeToOldEmail", { lang });

// 换绑邮箱->旧邮箱提交
export const verifyOldEmailCodeApi = (data) =>
  request.post("/verifyOldEmailCode", { lang, isFormData: true, ...data });

// 换绑邮箱 ->新邮箱提交
export const resetEmailApi = (data) =>
  request.post("/resetEmail", { lang, isFormData: true, ...data });

// 绑定邮箱--提交
export const bindEmailApi = (data) =>
  request.post("/bindEmail", { lang, isFormData: true, ...data });

// 绑定手机号 -- 提交
export const bindPhoneApi = (data) =>
  request.post("/bindPhoneNumber", { lang, isFormData: true, ...data });

// 修改用户头像/用户名
export const updateUserInfoApi = (data) =>
  request.post("/updateUserInfo", { lang, isFormData: true, ...data });

// 财务管理
export const getFinanceApi = (params) =>
  request.get("/finance", { lang, params });

// 获取当前用户订单统计（进行中/已完成）
export const getOrderStatsApi = (params) =>
  request.get("/orderStats", { lang, params });

// 我的订单
export const getOrderApi = (params) => request.get("/order", { lang, params });

// 获取支付记录
export const getPaymentRecordApi = (params) =>
  request.get("/paymentRecord", { lang, params });

// 获取优惠券列表
export const getCouponApi = (params) =>
  request.get("/coupons", { lang, params });

// 云服务续费
export const cloudRenewApi = (data) =>
  request.post("/order/renew", { lang, ...data });

// 取消支付
export const cancelPayApi = (params) =>
  request.get("/order/cancelPay", { lang, params });

// 支付完成审核状态
export const auditOrderApi = (params) =>
  request.get("/order/auditOrder", { lang, params });

// 公告未读列表
export const getNoticeApi = () => request.get("/announcements", { lang });

// 首页检查公告弹窗是否已读
export const getReadStatus = (id) =>
  request.get(`/announcement/read-status/${id}`, { lang });

// 公告已读
export const readNoticeApi = (id) =>
  request.post(`/announcements/${id}/read`, { lang });

// 全部已读
export const readAllNoticeApi = () =>
  request.post("/announcements/read-all", { lang });

// 反馈列表
export const getFeedbackApi = (params) =>
  request.get("/feedback", { lang, params });

// 删除反馈
export const deleteFeedbackApi = (id) =>
  request.delete(`/feedback/${id}`, { lang });

// 添加购物车
export const addToCartApi = (data) => request.post("/cart", { lang, ...data });

// 购物车列表
export const getCartApi = (params) => request.get("/cart", { lang, params });

// 删除购物车
export const deleteCartApi = (data) => request.delete("/cart", { lang, data });

//修改购物车项数量
export const updateCartApi = (data) =>
  request.patch(`/cart`, { lang, ...data });

// 购物车结算
export const settleCartApi = (data) =>
  request.post("/cart/checkout", { lang, ...data });

// 取消合并订单
export const decomposeApi = (data) =>
  request.post(`/order/decompose`, { lang, ...data });

// 我的账单-导出
export const financeExportApi = (params) =>
  request.get("/finance/export", { lang, params });

// 解除限制
export const removeLimitApi = (data) =>
  request.post("/removeRestrictions", { lang, ...data });

// 获取认证信息
export const getAuthInfoApi = () => request.get("/real-name-auth/my", { lang });

// 获取国籍列表
export const getNationalityApi = () =>
  request.get("/real-name-auth/countries", { lang });

// 获取身份类型列表
export const getIdentityTypeApi = () =>
  request.get("/real-name-auth/credential-types", { lang });

// 提交实名认证
export const submitRealNameAuthApi = (data) =>
  request.post("/real-name-auth/submit", { lang, ...data });
